import { useState } from "react";
import { useTranslation } from "react-i18next";

import { TotalAvgHistory, AccumulatedPerDate, Land, Ranking } from "./Charts";

const reportSections = [
  { id: "history", translationKey: "reports:ndvi.view.menu.ndvi_avg" },
  { id: "accumulated-per-date", translationKey: "reports:ndvi.view.menu.date_comparative" },
  { id: "ranking", translationKey: "reports:ndvi.view.menu.ranking" },
  { id: "land", translationKey: "reports:ndvi.view.menu.land" },
];

const ModalBody = ({ mobile = false }) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState("history");

  const changeReport = (choice) => (e) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }
    setSelected(choice);
  };

  const content = (
    <>
      {selected == "history" && <TotalAvgHistory />}
      {selected == "accumulated-per-date" && <AccumulatedPerDate />}
      {selected == "land" && <Land />}
      {selected == "ranking" && <Ranking />}
    </>
  );

  if (mobile) {
    return (
      <div className="reports-mobile-detail">
        <div className="reports-mobile-tabs" role="tablist" aria-label="Secciones del reporte de estado de cultivo">
          {reportSections.map((section) => (
            <button
              key={section.id}
              type="button"
              className={`reports-mobile-tab ${selected == section.id ? "active" : ""}`.trim()}
              onClick={changeReport(section.id)}
            >
              {t(section.translationKey)}
            </button>
          ))}
        </div>
        <div className="reports-mobile-detail__panel">
          {content}
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="modal-body p-5">
        <div className="row">
          <div className="col-3">
            <nav className="nav flex-column nav-pills">
              {reportSections.map((section) => (
                <a
                  key={section.id}
                  onClick={changeReport(section.id)}
                  className={"nav-link " + (selected == section.id ? "active" : "")}
                  aria-current="page"
                  href="#"
                >
                  {t(section.translationKey)}
                </a>
              ))}
            </nav>
          </div>
          <div className="col-9">{content}</div>
        </div>
      </div>
    </>
  );
};

export default ModalBody;
